<ion-app>
    <ion-router-outlet></ion-router-outlet>
    <p-toast />
    <p-confirmdialog />
</ion-app>